// /client/src/components/Dashboard.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navigation from './Navigation';
import RecentActivity from './RecentActivity';
import MessageQueueWidget from './MessageQueueWidget';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Sync state
  const [syncing, setSyncing] = useState(false);
  const [syncMessage, setSyncMessage] = useState('');

  // Sync all messages with Twilio
  const syncAllMessages = async () => {
    try {
      setSyncing(true);
      setSyncMessage('');
      const token = localStorage.getItem('token');
      
      const response = await fetch('/api/deployments/sync-all', {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      
      if (data.success) {
        setSyncMessage(`${data.message}`);
      } else {
        setSyncMessage(`${data.error || 'Sync failed'}`);
      }
    } catch (err) {
      setSyncMessage(`✗ ${err.message}`);
    } finally {
      setSyncing(false);
      // Clear message after 5 seconds
      setTimeout(() => setSyncMessage(''), 5000);
    }
  };

  return (
    <>
      {/* Main Content */}
      <section className="theme-light m-0 p-0" data-theme="light">
        <div className='is-flex is-flex-direction-column is-justify-content-center'>
          
          <Navigation />

          <div className='mt-6 pt-4 container px-4'>
            <h1 className='h1 my-2'>Hello, {user?.firstName || 'there'}.</h1>
            <p className=' my-2 pb-4'>What would you like to do today?</p>

            {/* Sync Message */}
            {syncMessage && (
              <div className={`notification ${syncMessage.startsWith('') ? 'is-success' : 'is-danger'} is-light py-2 mb-4`}>
                {syncMessage}
              </div>
            )}

            <div className="columns">
              {/* Left Column - Quick Actions */}
              <div className="column is-one-third">
                <div className="box boxHeight">
                  <h2 className="subtitle is-5 mb-3 is-bold">Quick Actions</h2>
                  <div className="buttons is-flex is-flex-direction-column">
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/programs/create')}
                    >
                      Create Program
                    </button>
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/products/create')}
                    >
                      Create Product
                    </button>
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/contacts/create')}
                    >
                      Create Contact
                    </button>
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/pods')}
                    >
                      Create Pod
                    </button>
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/deployments')}
                    >
                      Create Deployment
                    </button>
                    <hr className="my-2" style={{ width: '100%', borderTop: '1px solid #dbdbdb' }} />
                    <button 
                      className={`button is-info is-fullwidth ${syncing ? 'is-loading' : ''}`}
                      onClick={syncAllMessages}
                      disabled={syncing}
                    >
                      Sync Messages
                    </button>
                    <hr className="my-2" style={{ width: '100%', borderTop: '1px solid #dbdbdb' }} />
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/twilio-queue')}
                    >
                      Twilio Message Queue
                    </button>
                    <button 
                      className="button is-primary is-fullwidth"
                      onClick={() => navigate('/messages')}
                    >
                      App Message Log
                    </button>
                  </div>
                </div>
              </div>

              {/* Center Column - Message Queue */}
              <div className="column is-one-third">
                <MessageQueueWidget />
              </div>

              {/* Right Column - Recent Activity */}
              <div className="column is-one-third">
                <RecentActivity />
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default Dashboard;